import React from "react";
import { BrowserRouter, NavLink, Route } from "react-router-dom";
import ContentHeader from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import Main from "../../../Dashboard/Components/SystemSettings/SystemMetrics/SystemMetrics";
import OtherMetrics from "../../../Dashboard/Components/SystemSettings/SystemMetrics/OtherMetrics";

const SystemMetrics = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const validateNavigation = (e, Id) => {
    transformIndicator(Id);
  };
  const transformIndicator = (Id) => {
    if (Id === "other") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(137px)";
    } else if (Id === "ai-metrics") {
      document.getElementById("animated-indicator").style.transform = "none";
    }
  };
  return (
    <BrowserRouter basename="/home/systemMetrics">
      <div className="main-content security-settings system-settings app-settings">
        <ContentHeader PageName={translateText("system_metrics")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("system_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("system_metrics")}</p>
          </div>
        </div>
        <div className="navogator-holder">
          <div className="actions navigator navigator-sm metrics-nav">
            <span id="animated-indicator"></span>
            <NavLink
              onClick={(e) => validateNavigation(e, "ai-metrics")}
              activeClassName="active-nav-node"
              exact
              id="main"
              to="/"
              className="ai-metrics"
            >
              <p>{translateText("ai_metrics")}</p>
            </NavLink>
            <NavLink
              onClick={(e) => validateNavigation(e, "other")}
              activeClassName="active-nav-node"
              exact
              id="other"
              to="/otherMetrics"
            >
              <p>{translateText("other_metrics")}</p>
            </NavLink>
          </div>
        </div>{" "}
      </div>
      <Route path="/" exact>
        <Main LangData={props.LangData} />
      </Route>
      <Route path="/otherMetrics">
        <OtherMetrics LangData={props.LangData} />
      </Route>
    </BrowserRouter>
  );
};

export default SystemMetrics;
